export default {
    salesitemno: '項目No',
    salesitemname: '項目名称',
    standard: '規格・型番',
    unit: '単位',
    unitprice: '単価',
    costprice: '原価',
    memo: 'メモ'
};
